// @ts-nocheck
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import React from "react";

const RebateCalculator: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 14 15"
            fill="none"
            strokeWidth={0.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <g id="Xnix_x2F_Line_x2F_Calculator" transform="translate(0 .5)">
                <g id="Vector">
                    <path
                        id="vector-3"
                        stroke="currentColor"
                        d="M3.1 14C1.4 14 0 12.6 0 10.9V3.1C0 1.4 1.4 0 3.1 0h7.8C12.6 0 14 1.4 14 3.1v7.8c0 1.7-1.4 3.1-3.1 3.1H3.1z"
                    />
                    <path
                        id="vector-4"
                        stroke="currentColor"
                        d="M2.3 3.9v1.6c0 .4.3.8.8.8h7.8c.2 0 .4-.1.6-.2.1-.1.2-.3.2-.6V3.9c0-.4-.3-.8-.8-.8H3.1c-.4 0-.8.4-.8.8z"
                    />
                    <path
                        id="vector-5"
                        stroke="currentColor"
                        d="M10.1 8.6h1.6m-5.5 0h1.6m-5.5 0h1.6m-1.6 2.3h1.6m2.3 0h5.4"
                    />
                </g>
            </g>
        </svg>
    );
};

export const RebateCalculatorOffset: IconOffset = {
    vertical: 10,
    horizontal: 6,
};

export default React.memo(RebateCalculator);
